import fetch from "auth/FetchInterceptor";

const OrderService = {};

OrderService.getOrders = function (page = 1, pagelimit = 10, filters = {}) {
  // Build query parameters
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("pagelimit", pagelimit);

  // Add date filter
  if (filters.dateFilter) {
    params.append("date_filter", filters.dateFilter);
  }

  // Add custom date range
  if (filters.startDate) {
    params.append("start_date", filters.startDate);
  }
  if (filters.endDate) {
    params.append("end_date", filters.endDate);
  }

  // Add order status filter
  if (filters.orderStatus) {
    params.append("order_status_id", filters.orderStatus);
  }

  // Add payment status filter
  if (filters.paymentStatus) {
    params.append("payment_status", filters.paymentStatus);
  }

  // Free-text search across order_id, firstname, lastname, email, telephone.
  // The backend already understands the `search` query param.
  if (filters.search != null && String(filters.search).trim() !== "") {
    params.append("search", String(filters.search).trim());
  }

  return fetch({
    url: `/orders/?${params.toString()}`,
    method: "get",
  });
};

// Export orders to an Excel file. Mirrors the list filters so the export
// matches what the vendor is currently viewing.
OrderService.exportOrders = function (filters = {}) {
  const params = new URLSearchParams();
  if (filters.dateFilter) params.append("date_filter", filters.dateFilter);
  if (filters.startDate) params.append("start_date", filters.startDate);
  if (filters.endDate) params.append("end_date", filters.endDate);
  if (filters.orderStatus) params.append("order_status_id", filters.orderStatus);
  if (filters.search != null && String(filters.search).trim() !== "") {
    params.append("search", String(filters.search).trim());
  }
  const qs = params.toString();
  return fetch({
    url: `/orders/bulk/export/${qs ? `?${qs}` : ""}`,
    method: "get",
    responseType: "blob",
  });
};

OrderService.getOrder = function (id) {
  return fetch({
    url: `/orders/${id}`,
    method: "get",
  });
};

OrderService.updateOrders = function (data) {
  return fetch({
    url: `/orders/${data.id}/`,
    method: "put",
    data: { order_status_id: data.order_status_id },
  });
};

OrderService.deleteOrders = function ({ id }) {
  return fetch({
    url: `/orders/${id}/`,
    method: "delete",
  });
};

OrderService.bulkSoftDeleteOrders = async function ({ order_ids = [] }) {
  try {
    return await fetch({
      url: `/orders/bulk-soft-delete/`,
      method: "post",
      data: { order_ids },
    });
  } catch (error) {
    const status = error?.response?.status || error?.status;
    // Backward-compatible fallback: if bulk endpoint isn't available (404),
    // soft-delete each selected order using the existing single-delete API.
    if (Number(status) === 404) {
      const results = await Promise.allSettled(
        order_ids.map((id) => OrderService.deleteOrders({ id })),
      );
      const updated_count = results.filter((r) => r.status === "fulfilled").length;
      if (updated_count === 0) {
        throw error;
      }
      return {
        success: true,
        updated_count,
        fallback: true,
      };
    }
    throw error;
  }
};

OrderService.manageAllowmenaOrder = function ({ id, action }) {
  return fetch({
    url: `/orders/${id}/allowmena/`,
    method: "post",
    data: { action },
  });
};

OrderService.manageRidersOrder = function ({ id, action, ...data }) {
  return fetch({
    url: `/orders/${id}/riders/`,
    method: "post",
    data: { action, ...data },
  });
};

OrderService.getRidersGeo = function (resource, parent = {}) {
  const params = new URLSearchParams({ resource, ...parent });
  return fetch({
    url: `/riders/geo/?${params.toString()}`,
    method: "get",
  });
};

export default OrderService;
